
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI_ from './kotlinx-browser.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4 from './kotlinx-coroutines-coreWasm.mjs';
import * as Li9za2lrby5tanM from './skiko.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS } from './kotlinx-browser.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS } from './kotlinx-coroutines-coreWasm.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;

const js_code = {
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_class_instanceof' : (x) => x instanceof FinalizationRegistry,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_class_get' : () => FinalizationRegistry,
    'org.jetbrains.skia.impl.crateCallbackObj' : () => { return {} },
    'org.jetbrains.skia.impl.value_$external_prop_getter' : (_this) => _this.value,
    'org.jetbrains.skia.impl.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'org.jetbrains.skia.impl.value_$external_prop_getter_1' : (_this) => _this.value,
    'org.jetbrains.skia.impl.value_$external_prop_setter_1' : (_this, v) => _this.value = v,
    'org.jetbrains.skia.impl.value_$external_prop_getter_2' : (_this) => _this.value,
    'org.jetbrains.skia.impl.value_$external_prop_setter_2' : (_this, v) => _this.value = v,
    'org.jetbrains.skia.impl.value_$external_prop_getter_3' : (_this) => _this.value,
    'org.jetbrains.skia.impl.value_$external_prop_setter_3' : (_this, v) => _this.value = v,
    'org.jetbrains.skia.impl._registerCallback_$external_fun' : (p0, p1, p2) => _ref_Li9za2lrby5tanM_c2tpa29BcGk._registerCallback(p0, p1, p2),
    'org.jetbrains.skia.impl.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'org.jetbrains.skia.impl._createLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._createLocalCallbackScope(),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skia.webext.skikoArrayBuffer' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'org.jetbrains.skia.webext.copyBuffer' : (src, dst, dstOffset) => { 
            var dstView = new Uint8Array(dst);
            var srcView = new Uint8Array(src);
            dstView.set(srcView, dstOffset);
         },
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.wasm.alpha_$external_prop_getter' : (_this) => _this.alpha,
    'org.jetbrains.skiko.wasm.depth_$external_prop_getter' : (_this) => _this.depth,
    'org.jetbrains.skiko.wasm.stencil_$external_prop_getter' : (_this) => _this.stencil,
    'org.jetbrains.skiko.wasm.antialias_$external_prop_getter' : (_this) => _this.antialias,
    'org.jetbrains.skiko.wasm.premultipliedAlpha_$external_prop_getter' : (_this) => _this.premultipliedAlpha,
    'org.jetbrains.skiko.wasm.preserveDrawingBuffer_$external_prop_getter' : (_this) => _this.preserveDrawingBuffer,
    'org.jetbrains.skiko.wasm.preferLowPowerToHighPerformance_$external_prop_getter' : (_this) => _this.preferLowPowerToHighPerformance,
    'org.jetbrains.skiko.wasm.failIfMajorPerformanceCaveat_$external_prop_getter' : (_this) => _this.failIfMajorPerformanceCaveat,
    'org.jetbrains.skiko.wasm.enableExtensionsByDefault_$external_prop_getter' : (_this) => _this.enableExtensionsByDefault,
    'org.jetbrains.skiko.wasm.explicitSwapControl_$external_prop_getter' : (_this) => _this.explicitSwapControl,
    'org.jetbrains.skiko.wasm.renderViaOffscreenBackBuffer_$external_prop_getter' : (_this) => _this.renderViaOffscreenBackBuffer,
    'org.jetbrains.skiko.wasm.majorVersion_$external_prop_getter' : (_this) => _this.majorVersion
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-coroutines-core>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWNvcm91dGluZXMtY29yZT4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-browser>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS,
    './skiko.mjs': Li9za2lrby5tanM,
};
    